export const ErrorMessageDisplayTime = 3 * 1000

export const ResponseSuccess = 2000
export const NOT_AUTHORIZED_CODE = 401
